
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'

/** Страница регистрации на вебинар. */
const REGISTRATION_URL =
    'https://dataheroes.pro/news?utm_source=dhp&utm_medium=dhpnew&utm_campaign=webinar1210'

/** Начало вебинара, 12 октября 12:00 МСК. Позже этого момента анонс не показываем. */
const SHOW_UNTIL = new Date('2026-10-12T12:00:00+03:00').getTime()

/** Показали в этой сессии — в рамках вкладки больше не дёргаем. */
const SESSION_KEY = 'webinarAnnouncement-2026-10-12-shown'

/** Нажал «Зарегистрироваться» — анонс отработал, больше не показываем вообще. */
const REGISTERED_KEY = 'webinarAnnouncement-2026-10-12-registered'

/** Пауза перед показом: даём странице и модалке переподключения успеть открыться. */
const OPEN_DELAY_MS = 1500

function read(store: Storage | null, key: string): boolean {
    try {
        return Boolean(store?.getItem(key))
    } catch (e) {
        // приватный режим: хранилище недоступно — считаем, что не показывали
        return false
    }
}

function write(store: Storage | null, key: string): void {
    try {
        store?.setItem(key, '1')
    } catch (e) {
        // приватный режим — переживём, покажем ещё раз
    }
}

export default defineComponent({
    name: 'WebinarAnnouncementModal',
    setup() {
        const isOpen = ref(false)
        const art = require('@/assets/img/announcements/webinar-2026-10-12.webp')
        let timer: any = null

        // Закрыли анонс — он вернётся в следующую сессию, так просил заказчик.
        const dismiss = () => {
            isOpen.value = false
        }

        const register = () => {
            write(window.localStorage, REGISTERED_KEY)
            window.open(REGISTRATION_URL, '_blank', 'noopener,noreferrer')
            isOpen.value = false
        }

        onMounted(() => {
            if (Date.now() >= SHOW_UNTIL) return
            if (read(window.localStorage, REGISTERED_KEY)) return
            if (read(window.sessionStorage, SESSION_KEY)) return

            timer = setTimeout(() => {
                // Переезд со сторонних провайдеров важнее анонса: если на экране уже
                // висит модалка переподключения — молчим и попробуем в следующий заход.
                if (document.querySelector('.rc-dialog')) return
                write(window.sessionStorage, SESSION_KEY)
                isOpen.value = true
            }, OPEN_DELAY_MS)
        })

        onUnmounted(() => {
            if (timer) clearTimeout(timer)
        })

        return { isOpen, art, dismiss, register }
    },
})
